"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = updateConnectionStatus;
exports.UPDATE_CONNECTION_STATUS = void 0;
var UPDATE_CONNECTION_STATUS = 'DIRECT_LINE/UPDATE_CONNECTION_STATUS';
exports.UPDATE_CONNECTION_STATUS = UPDATE_CONNECTION_STATUS;

function updateConnectionStatus(connectionStatus) {
  return {
    type: UPDATE_CONNECTION_STATUS,
    payload: {
      connectionStatus: connectionStatus
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3VwZGF0ZUNvbm5lY3Rpb25TdGF0dXMuanMiXSwibmFtZXMiOlsiVVBEQVRFX0NPTk5FQ1RJT05fU1RBVFVTIiwidXBkYXRlQ29ubmVjdGlvblN0YXR1cyIsImNvbm5lY3Rpb25TdGF0dXMiLCJ0eXBlIiwicGF5bG9hZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHdCQUF3QixHQUFHLHNDQUFqQzs7O0FBRWUsU0FBU0Msc0JBQVQsQ0FBZ0NDLGdCQUFoQyxFQUFrRDtBQUMvRCxTQUFPO0FBQ0xDLElBQUFBLElBQUksRUFBRUgsd0JBREQ7QUFFTEksSUFBQUEsT0FBTyxFQUFFO0FBQUVGLE1BQUFBLGdCQUFnQixFQUFoQkE7QUFBRjtBQUZKLEdBQVA7QUFJRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFVQREFURV9DT05ORUNUSU9OX1NUQVRVUyA9ICdESVJFQ1RfTElORS9VUERBVEVfQ09OTkVDVElPTl9TVEFUVVMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1cGRhdGVDb25uZWN0aW9uU3RhdHVzKGNvbm5lY3Rpb25TdGF0dXMpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBVUERBVEVfQ09OTkVDVElPTl9TVEFUVVMsXG4gICAgcGF5bG9hZDogeyBjb25uZWN0aW9uU3RhdHVzIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgVVBEQVRFX0NPTk5FQ1RJT05fU1RBVFVTIH07XG4iXX0=